import { Droppable } from "@hello-pangea/dnd";
import MenuItem from "./MenuItem";

const MenuItems = ({
  section,
  editMode,
  handleItemUpdate,
  handleItemDelete,
}) => {
  const droppableId = `section-${section.id}`;

  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <div className="menu-section-items" ref={provided.innerRef}>
          {section.items.map((item, index) => (
            <MenuItem
              key={item.id}
              item={item}
              index={index}
              dragHandleProps={provided.dragHandleProps}
              editMode={editMode}
              handlerFunctions={{
                onItemUpdate: handleItemUpdate,
                onItemDelete: handleItemDelete,
              }}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default MenuItems;
